import { render, staticRenderFns } from "./JcdcFullscreenDialog.vue?vue&type=template&id=92f67250"
import script from "./JcdcFullscreenDialog.vue?vue&type=script&lang=ts"
export * from "./JcdcFullscreenDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports